// import React from 'react';
// import { Button, Dropdown, Menu } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
// import './CreateDropdown.css'

// const CreateDropdown = ({ onSelect }) => {
//   const menu = (
//     <Menu
//       onClick={(e) => {
//         onSelect?.(e.key);
//       }}
//       items={[
//         { label: 'Appointment', key: 'APPOINMENT',style:{fontSize : 18 } },
//         { label: 'Spacer', key: 'SPACER',style:{fontSize : 18} },
//         { label: 'Lunch Break', key: 'LUNCH',style:{fontSize : 18} },
//         { label: 'Block', key: 'BLOCK',style:{fontSize : 18} },
//       ]}
//     />
//   );

//   return (
//     <Dropdown overlay={menu} style={{with : 150}} trigger={['click']} overlayClassName="custom-dropdown-width">
//       <Button className='add-generic-btn' type="text" icon={<PlusOutlined />} style={{ fontWeight: 'bold', color: '#008385' }}>
//         Create
//       </Button>
//     </Dropdown>
//   );
// };

// export default CreateDropdown;

import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './CreateDropdown.css';

const CreateDropdown = ({ onSelect }) => {
  const menuItems = [
    { label: 'Appointment', key: 'APPOINMENT', style: { fontSize: 18 } },
    { label: 'Spacer', key: 'SPACER', style: { fontSize: 18 } },
    { label: 'Lunch Break', key: 'LUNCH', style: { fontSize: 18 } },
    { label: 'Block', key: 'BLOCK', style: { fontSize: 18 } },
  ];

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: (e) => {
          onSelect?.(e.key);
        },
      }}
      trigger={['click']}
      overlayClassName="custom-dropdown-width"
    >
      <Button
        className="add-generic-btn"
        type="text"
        icon={<PlusOutlined />}
        style={{ fontWeight: 'bold', color: '#008385' }}
      >
        Create
      </Button>
    </Dropdown>
  );
};

export default CreateDropdown;

